import React from 'react';
import { Col, Row, Form } from 'react-bootstrap';
import { Avatar } from '@mui/material';
import { toast } from 'react-hot-toast';
import { useAccount } from 'wagmi';
import { createTeam } from '../../web3/SFM-TeamsUtils';
import SocialTooltip from '../../social-wallet/tooltip';
import axios from 'axios';

//adding new campaign page
const TeamSingle = ({
  item,
  isAdd,
  CallAddUpdateCanceled,
  callSaveSucceed,
  isMyTeam = false,
}) => {
  const { address } = useAccount();
  const fileImgInput = React.useRef();

  const [state, setState] = React.useState({
    inputs: {
      id: item && item.id ? item.id : '',
      name: item && item.name ? item.name : '',
      treasury: item && item.leader ? item.leader : isAdd ? address : '',
      description: item && item.description ? item.description : '',
      rules: item && item.rules ? item.rules : '',
      leaderImage: item && item.leaderURI ? item.leaderImage : '',
      memberImage: item && item.memberURI ? item.memberImage : '',
      leaderURI: item && item.leaderURI ? item.leaderURI : '',
      memberURI: item && item.memberURI ? item.memberURI : '',
      joiningFees:
        item && item.joiningFee
          ? parseInt(item.joiningFee) / Math.pow(10, 18)
          : '',
      requiresApproval:
        item && item.requiresApproval ? item.requiresApproval : '',
      balance: item && item.balance ? item.balance : '',
      initialFunding: item && item.initialFunding ? item.initialFunding : '',
      fundTokens: '',
    },
  });
  const [isButtonClicked, setIsButtonClicked] = React.useState(false);
  const [uploadedImage, setUploadedImage] = React.useState();
  const [teamImage, setTeamImage] = React.useState(
    address === item.leader
      ? state.inputs.leaderImage
      : state.inputs.memberImage
  );

  const handleChange = (e) => {
    const { value, name, checked, type } = e.target;
    const { inputs } = state;
    inputs[name] = type === 'checkbox' ? checked : value;
    setState({
      ...state,
      inputs,
    });
  };

  const upload = async (e) => {
    setTeamImage(URL.createObjectURL(e.target.files[0]));
    setUploadedImage(e.target.files[0]);
  };

  const saveCreatedTeam = async () => {
    try {
      const { description, name, joiningFees, rules } = state.inputs;
      setIsButtonClicked(true);
      let leaderImageURI;
      let memberImageURI;
      var formdata = new FormData();
      formdata.append('file', uploadedImage);
      formdata.append(
        'nftAttributes',
        JSON.stringify({
          name: name,
          description: description,
          rules: rules,
          joiningFees: joiningFees,
        })
      );
      const response = await axios({
        method: 'post',
        url: `${process.env.REACT_APP_UPLOAD_NFT_IMAGE}/uploadTeamNFTBase64`,
        data: formdata,
        headers: {
          'Content-Type': `multipart/form-data; boundary=${formdata._boundary}`,
        },
      });
      leaderImageURI = response.data.uriHash + '/leader.json';
      memberImageURI = response.data.uriHash + '/member.json';
      leaderImageURI &&
        memberImageURI &&
        createNewTeam(leaderImageURI, memberImageURI);
    } catch (err) {
      toast.error(err.message);
    }
    //setIsButtonClicked(false);
  };
  const createNewTeam = async (leaderImageURI, memberImageURI) => {
    try {
      const {
        name,
        description,
        rules,
        requiresApproval,
        joiningFees,
        initialFunding,
      } = state.inputs;
      //setIsButtonClicked(true);
      const savedTeam = await createTeam(
        name,
        description,
        rules,
        leaderImageURI,
        memberImageURI,
        requiresApproval,
        joiningFees,
        initialFunding
      ).then((e) => {
        console.log(e);
        toast.success('Team created successfully');
        setIsButtonClicked(false);
        callSaveSucceed();
      });
    } catch (err) {
      if (err?.code == 'ACTION_REJECTED') {
        toast.error('You have canceled the transaction');
      } else {
        toast.error(err.message);
      }
    }
    setIsButtonClicked(false);
  };
  const handleCancel = (e) => {
    CallAddUpdateCanceled();
  };

  return (
    <div className="team-card py-3">
      {/* <!-- Team --> */}

      <Row className="mb-3">
        <Col className="col-auto">
          <Row className="mb-3">
            <Col>
              <label className="position-relative">
                <Avatar alt="" src={teamImage} className="team-image" />
                <input
                  accept="*/*"
                  className="d-none"
                  type="file"
                  ref={fileImgInput}
                  onChange={(e) => upload(e)}
                  disabled={!isAdd}
                />
                <span className="text-danger required-field-symbol">*</span>
              </label>
            </Col>
          </Row>
        </Col>

        <Col>
          <Row className="mb-3">
            <SocialTooltip title={'Name'}>
              <Col className="position-relative">
                <input
                  value={state.inputs.name}
                  onChange={handleChange}
                  className="form-control"
                  disabled={!isAdd}
                  name="name"
                  placeholder="Name (Required)"
                />
                <span className="text-danger required-field-symbol">*</span>
              </Col>
            </SocialTooltip>
            <SocialTooltip title={'Treasury (Your Metamask Address)'}>
              <Col className="position-relative">
                <input
                  value={state.inputs.treasury}
                  onChange={handleChange}
                  className="form-control"
                  disabled={true}
                  name="treasury"
                  placeholder="Treasury (Required)"
                />
                <span className="text-danger required-field-symbol">*</span>
              </Col>
            </SocialTooltip>
            <Col className="col-auto">
              <button
                onClick={() => {
                  saveCreatedTeam();
                }}
                className={`btn-inner-form ${
                  isAdd || !isMyTeam ? 'btn-success' : 'btn-danger'
                }`}
                disabled={
                  state.inputs.name === '' ||
                  state.inputs.treasury === '' ||
                  state.inputs.rules === '' ||
                  state.inputs.description === '' ||
                  uploadedImage === undefined ||
                  state.inputs.joiningFees === '' //||
                  //state.inputs.memberURI === ''
                }
              >
                {isButtonClicked ? (
                  <div className="lds-dual-ring"></div>
                ) : (
                  'Create'
                )}
              </button>
            </Col>
          </Row>
          <Row className="mb-3">
            <SocialTooltip title={'Description'}>
              <Col className="position-relative">
                <textarea
                  value={state.inputs.description}
                  onChange={handleChange}
                  className="form-control"
                  disabled={!isAdd}
                  name="description"
                  placeholder="Description (Required)"
                />
                <span className="text-danger required-field-symbol">*</span>
              </Col>
            </SocialTooltip>
          </Row>
          <Row className="mb-3">
            <SocialTooltip title={'Rules'}>
              <Col className="position-relative">
                <textarea
                  className="form-control"
                  disabled={!isAdd}
                  name="rules"
                  placeholder="Rules (Required)"
                  onChange={handleChange}
                  value={state.inputs.rules}
                />
                <span className="text-danger required-field-symbol">*</span>
              </Col>
            </SocialTooltip>
          </Row>
          <Row className="mb-3">
            <Col>
              <Form.Check
                type="checkbox"
                id={`requiresApproval`}
                label={`Require Approval`}
                name="requiresApproval"
                value={state.inputs.requiresApproval}
                onChange={handleChange}
                disabled={!isAdd}
                checked={state.inputs.requiresApproval}
              />
            </Col>
            <SocialTooltip title={'Joining Fees'}>
              <Col className="position-relative">
                <input
                  className="form-control"
                  disabled={!isAdd}
                  name="joiningFees"
                  placeholder="Joining Fees (Required)"
                  onChange={handleChange}
                  value={state.inputs.joiningFees}
                  type="number"
                  min="0"
                />
                <span className="text-danger required-field-symbol">*</span>
              </Col>
            </SocialTooltip>
          </Row>
          <Row className="mb-3">
            <Col>
              <SocialTooltip title={'Initial Funding'}>
                <input
                  className="form-control"
                  name="initialFunding"
                  placeholder="Initial Funding"
                  onChange={handleChange}
                  value={state.inputs.initialFunding}
                  type="number"
                  min="0"
                />
              </SocialTooltip>
            </Col>
          </Row>
        </Col>
      </Row>

      {isAdd && (
        <Row className="mt-4">
          <Col>
            <p className="form-submit">
              <button
                className="btn-inner-form btn-default"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </p>
          </Col>
        </Row>
      )}

      {/* <!-- Team END --> */}
    </div>
  );
};

export default TeamSingle;
